<template lang="pug">
b-container(@contextmenu.prevent="$refs.menu.open($event)" ref="container")
  b-form-row.align-items-center.mt-3.mb-4
    b-col.mb-2.mb-md-0
      h4.mb-0 Flujos
      //.text-help
        alert-circle-icon.icon-md.mr-1
        span Los flujos te permiten agrupar bloques de conversación para una mejor organización.
    b-col(md="auto")
      b-button.mr-2(variant="primary", @click="editFlow") Crear flujo
      //b-dropdown(right, variant="light", no-caret)
        template(slot="button-content")
          more-vertical-icon.icon-sm
        b-dropdown-item(@click="platformModal = true") Plataformas
        b-dropdown-item Clonar plantillas
  b-card(no-body)
    template(slot="header")
      b-input-group
        b-form-input(type="search", placeholder="Buscar flujo...", v-model="searchFlow", @input="searchFlows")
        b-input-group-append
          b-input-group-text
            search-icon.text-dark.icon-sm
      .mt-2(v-if="recent_flows.length")
        .text-sm.text-secondary.mb-1 Flujos abiertos recientemente:
        b-button.mr-2(variant="light", size="sm", v-for="recent in recent_flows", :key="recent.flow_id", @click.stop="goToFlow(recent, true)") {{recent.name}}
    b-table.card-table.mb-0(id="theFlows", :items="flowsFound.slice((currentPage - 1) * perPage, (currentPage - 1) * perPage + perPage)", responsive, hover, :fields="fields", show-empty, @row-clicked="goToFlow($event)" @row-hovered="hoverFlow($event)" @row-unhovered="unhoverFlow")
      template(v-slot:empty)
        p.mb-0.text-secondary No hay flujos disponibles
      template(v-slot:cell(name)="{ item }")
        p.mb-0(:class="{ 'text-secondary': !item.name }") {{ item.name || 'Sin nombre' }}
        p.mb-0.text-secondary.text-sm Creado el {{ $moment(item.createdAt).format('DD [de] MMMM YYYY, HH:mm A') }}
        b-badge.mt-2(v-if="item.default", variant="primary") Flujo default
      template(v-slot:cell(acciones)="{ item }")
        b-button.mr-2(variant="link", size="sm", @click.stop="editFlow(item)", v-b-tooltip.hover="'Editar'")
          edit-3-icon.icon-sm.text-secondary
        b-dropdown(variant="primary", size="sm", right, split, split-variant="outline-primary", @click.stop="goToFlow(item, true)", :menu-class="['w-250']", boundary="window")
          template(slot="button-content")
            external-link-icon.icon-sm
          b-dropdown-header Bloques {{item.Blocks ? item.Blocks.length : 0}}
          b-dropdown-form
            k-select(:options="parseBlocks(item)", placeholder="- Bloques de flujo -", @input="goToFlow(item, true, $event)")
          //b-dropdown-item(v-for="block in item.Blocks", :key="block.block_id", @click.stop="goToFlow(item, true, block.block_id)") {{block.name}} ({{block.block_id}})
          b-dropdown-divider
          b-dropdown-item(@click.stop="goToBuilder(item)")
            git-pull-request-icon.icon-md.mr-2
            span Diagrama de flujo
          b-dropdown-divider
          //b-dropdown-item(@click.stop="cloneFlow(item)")
            copy-icon.icon-md.mr-2
            span Clonar flujo
  .d-flex.align-items-center.mb-3(v-if="flowsFound.length")
    b-pagination.mb-3.mr-3(aria-controls="theFlows", v-model="currentPage", :per-page="perPage", :total-rows="flowsFound.length")
    //b-spinner(small, variant="primary", v-if="loading")
  b-modal(v-model="flowModal", :title="flow.flow_id ? 'Actualizar flujo' : 'Crear flujo'", :ok-title="flow.flow_id ? 'Actualizar' : 'Crear'", cancel-title="Cancelar", ok-variant="primary", @ok="beforeUpdateOrCreate", @hidden="flowValidated = false", :ok-disabled="loading")
    b-form-group(label="Nombre de flujo", label-size="sm")
      b-form-input(placeholder="Nombre de flujo", v-model="flow.name", :state="flowValidated ? !!flow.name : null")
    b-form-group(v-if="flow.flow_id", label="Listas de flujo", label-size="sm")
      treeselect.mb-2(:options="parsedLists", placeholder="- Listas de flujo -", v-model="flow.lists", v-bind="threeSelectOptions", :multiple="true", :clearable="false", @select="addList", @deselect="removeList")
    b-form-group(description="El usuario se enviará a este flujo en caso de que no haya entrenamiento o acción definida previamente")
      b-form-checkbox(v-model="flow.default") Es flujo default
    b-form-checkbox.mt-3(size="sm", v-model="openAfterCreate", v-if="!flow.flow_id") Abrir flujo después de crearlo
    b-card.bg-light.text-center.text-sm.mb-0.mt-4(v-if="flow.flow_id")
      alert-triangle-icon.icon-sm.mr-2
      span Eliminar flujo no se puede deshacer.
      p.mb-0.mt-2
        b-link.text-danger(@click="confirmDeleteFlow") Eliminar flujo
  b-modal(v-model="platformModal", title="Plataformas", ok-only, ok-title="Aceptar", ok-variant="primary", :ok-disabled="loading")
    p It's Britney bitch
  RightMenu(:menuItems='menuItems', ref="menu", :flowId="elementToCopy", :flowName="flowName", @movedFlow="handleFlow")
</template>

<script>
import { createNamespacedHelpers, mapActions } from 'vuex'
import RightMenu from '../../components/RightMenu.vue'
import _debounce from 'lodash.debounce'
import threeSelectOptions from '@/data/treeselect-options'
import Select from '../../components/Select'
import clipboard from '../../helpers/clipboard'

const flowController = createNamespacedHelpers('flow')
const listController = createNamespacedHelpers('list')
const TEN_SECONDS = 10000

export default {
  mixins: [clipboard],
  data() {
    return {
      clipboardElement: 'flow',
      reloadData: this.getFlows,
      menuItems: [
        {
          disabled: false,
          icon: 'copy',
          title: 'Copiar',
          action: this.copy
        },
        {
          disabled: true,
          icon: 'clipboard',
          title: 'Pegar',
          action: this.paste
        },
        {
          disabled: false,
          icon: 'plus-circle',
          title: 'Mover flujo',
          action: this.send
        }
      ],
      threeSelectOptions,
      loading: false,
      flowModal: false,
      flowValidated: false,
      platformModal: false,
      openAfterCreate: true,
      searchFlow: '',
      flow: {
        name: '',
        default: false,
        lists: []
      },
      fields: [
        { key: 'flow_id', label: 'ID' },
        { key: 'name', label: 'Nombre' },
        { key: 'acciones' }
      ],
      changedFlow: '',
      flowName: '',
      currentPage: 1,
      perPage: 20,
      flowsFound: []
    }
  },
  computed: {
    ...flowController.mapState({
      flows: state => state.flows,
      recent_flows: state => state.recent_flows
    }),
    ...listController.mapState({
      lists: state => state.lists
    }),
    parsedLists() {
      return this.lists.map((list) => {
        return { label: list.name, id: list.id }
      })
    }
  },
  methods: {
    ...mapActions([
      'list/all',
      'flow/all',
      'flow/create',
      'flow/update',
      'flow/destroy',
      'flow/translate',
      'flow/clone',
      'flow/getLists',
      'flow/addList',
      'flow/removeList'
    ]),
    hoverFlow(flow = {}) {
      const { flow_id: flowId, name } = flow || {}

      if (!flowId) return

      this.elementToCopy = flowId
      this.flowName = name
    },
    unhoverFlow: _debounce(function () {
      this.elementToCopy = null

      if (this.$refs.menu) this.$refs.menu.close()
    }, TEN_SECONDS),
    getLists() {
      const self = this
      this.loading = true

      this['list/all']({
        account_id: self.$route.params.account_id,
        callback: (res) => {
          self.loading = false

          if (res.error) return self.$message.error(res.error)
        }
      })
    },
    handleFlow(value) {
      this.changedFlow = value
    },
    getFlows() {
      const self = this
      this.loading = true
      //const params = { ...self.paginationParamsObject }
      const params = {}

      if (this.searchFlow) params.name = this.searchFlow

      this['flow/all']({
        account_id: self.$route.params.account_id,
        params,
        callback: (res) => {
          self.loading = false

          if (res.error) return self.$message.error(res.error)

          this.flowsFound = res.resource
          //self.parsePaginationDataFromResponse(res)
        }
      })
    },
    searchFlows: _debounce(function () {
      this.resetPaginationData()
      this.getFlows()
    }, 1000, { leading: false, trailing: true }),
    createFlow() {
      const self = this
      this.loading = true

      this['flow/create']({
        account_id: self.$route.params.account_id,
        ...self.flow,
        callback: (res) => {
          self.loading = false

          if (res.error) return self.$message.error(res.error)

          self.$message.success('Flujo creado')
          self.flowModal = false

          if (self.openAfterCreate) self.goToFlow(res.resource)
        }
      })
    },
    getFlowLists(flow) {
      const self = this
      this.loading = true

      this['flow/getLists']({
        params: { flow_id: flow.flow_id },
        callback: (res) => {
          self.loading = false

          if (res.error) return self.$message.error(res.error)

          const { resource = [] } = res
          this.flow.lists = resource.map(({ list_id: elementId }) => elementId)
        }
      })
    },
    updateFlow() {
      const self = this
      this.loading = true

      this['flow/update']({
        account_id: self.$route.params.account_id,
        ...self.flow,
        callback: (res) => {
          self.loading = false

          if (res.error) return self.$message.error(res.error)

          self.$message.success('Flujo actualizado')
          self.flowModal = false
        }
      })
    },
    beforeUpdateOrCreate(event) {
      event.preventDefault()

      this.flowValidated = false

      if (!this.flow.name) this.flowValidated = true

      return (this.flow.flow_id) ? this.updateFlow() : this.createFlow()
    },
    async confirmDeleteFlow() {
      try {
        const response = await this.$bvModal.msgBoxConfirm(
          '¿Deseas eliminar el flujo? No se puede deshacer.',
          {
            title: 'Eliminar flujo',
            okVariant: 'danger',
            okTitle: 'Eliminar flujo',
            cancelTitle: 'Cancelar'
          }
        )

        if (response) this.deleteFlow()
      } catch (e) {
        console.error(e.message)
      }
    },
    deleteFlow() {
      const self = this
      this.loading = true

      this['flow/destroy']({
        account_id: self.$route.params.account_id,
        ...self.flow,
        callback: (res) => {
          self.loading = false

          if (res.error) return self.$message.error(res.error)

          self.$message.success('Flujo eliminado')
          self.flowModal = false
        }
      })
    },
    translate() {
      const self = this
      const jsonData = {
        old_language_id: data.old_lang,
        new_language_id: data.new_lang,
        account_id: self.$route.params.account_id
      }

      this['flow/translate']({
        ...jsonData,
        callback: (res) => {
          if (res.error) return self.$message.error(res.error)
        }
      })
    },
    cloneFlow(flow) {
      const self = this
      this.loading = true
      this['flow/clone']({
        account_id: self.$route.params.account_id,
        flow_id: flow.flow_id,
        callback: (res) => {
          this.loading = false
          if (res.error) {
            self.$message.error(res.error)
          } else {
            self.$message.success('Flujo clonado')
          }
        }
      })
    },
    editFlow(flow) {
      this.clearObject(this.flow)

      if (flow && flow.flow_id) {
        this.flow = Object.assign(this.flow, flow)

        this.getFlowLists(flow)
      }

      this.flowModal = true
    },
    goToFlow(flow, blank = false, blockId) {
      const data = {
        name: 'Flow editor',
        params: { flow_id: flow.flow_id }
      }

      if (blockId) {
        data.name = 'Block'
        data.params.block_id = blockId
      }

      this.$store.commit('flow/setRecentFlows', flow)

      if (blank) {
        const route = this.$router.resolve(data)

        window.open(route.href, '_blank')
      } else {
        this.$router.push(data).catch(() => {})
      }
    },
    goToBuilder(flow) {
      const route = this.$router.resolve({
        name: 'Flow builder',
        params: { flow_id: flow.flow_id }
      })

      window.open(route.href, '_blank')
    },
    addList(node) {
      const self = this
      this.loading = true

      this['flow/addList']({
        flow_id: self.flow.flow_id,
        list_id: node.id,
        callback: (res) => {
          self.loading = false

          if (res.error) return self.$message.error(res.error)

          this.getFlowLists(self.flow)
          self.$message.success('Lista agregada')
        }
      })
    },
    removeList(node) {
      const self = this
      this.loading = true

      this['flow/removeList']({
        flow_id: self.flow.flow_id,
        list_id: node.id,
        callback: (res) => {
          self.loading = false

          if (res.error) return self.$message.error(res.error)

          this.getFlowLists(self.flow)
          self.$message.success('Lista removida')
        }
      })
    },
    parseBlocks({ Blocks = [] }) {
      return Blocks.map(({ block_id: id, name }) => ({
        label: `${name} (${id})`,
        id
      }))
    }
  },
  watch: {
    clipboardData(val) {
      this.menuItems[1].disabled = Boolean(!val)
    },
    changedFlow() {
      const index = this.flows.findIndex((flow) => flow.name === this.changedFlow.name)

      if (index > -1) this.flows.splice(index, 1)

      return this.flows
    }
  },
  mounted() {
    this.getLists()
    this.getFlows()
  },
  components: { 'k-select': Select, RightMenu }
}
</script>

<style lang="scss">
.w-250 {
  width: 250px !important;
}
</style>
